/**
 * RPDM W1-D · Route-level feature-flag gates.
 *
 * Two guard components, both fail-closed:
 *
 *   RequireRpdmSurface — mounts children iff `flagKey` is on. Redirects
 *   to `fallback` otherwise. Called at every workspace route so the
 *   FE cannot accidentally render a W1-D surface with flags off.
 *
 *   RequireSuperAdmin — extra guard for the Settings route. Redirects
 *   non-super-admins to the engagement summary landing (or /projects
 *   if the summary is also disabled).
 */
import { Navigate, useParams } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { useRpdmWorkspaceGate } from "@/hooks/useRpdmWorkspaceGate";

export function RequireRpdmSurface({ gateKey, fallback, children }) {
    const gates = useRpdmWorkspaceGate();
    if (gates[gateKey] !== true) {
        return <Navigate to={fallback} replace />;
    }
    return children;
}

export function RequireSuperAdmin({ children }) {
    const { user, loading } = useAuth();
    const { id } = useParams();
    if (loading) return null;
    if (user?.role !== "super_admin") {
        return <Navigate to={`/projects/${id}`} replace />;
    }
    return children;
}
